import { gql } from '@eti/schema-types';

export const CANCEL_WITH_REFUND_OFFER = gql(/* GraphQL */ `
  mutation CancelOrderWithRefundOffer($refundOfferId: Long!) {
    cancelOrderWithRefundOffer(refundOfferId: $refundOfferId) {
      success
    }
  }
`);
